import pkg from "../../package.json";

export const version = pkg.version;
